import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { api } from "@/lib/api";
import RetailerCTA from "@/components/RetailerCTA";
import AffiliateNote from "@/components/AffiliateNote";
import { PriceDropBadge, Price } from "@/components/PriceDrop";

export const LookCard = ({ p, i, source = "look" }) => (
  <div
    className="brut bg-white text-black flex flex-col pcs-look-card"
    style={{ animationDelay: `${i * 80}ms` }}
    data-testid={`${source}-card-${p.slug}`}
  >
    <Link to={`/product/${p.slug}`} className="relative block overflow-hidden border-b-2 border-black">
      {p.pick_label && (
        <span className="absolute top-2 left-2 z-10 brut pcs-bg-pink text-white px-2 py-0.5 font-mono uppercase text-[9px] tracking-widest" data-testid={`look-pick-label-${p.slug}`}>
          {p.pick_label}
        </span>
      )}
      <PriceDropBadge product={p} compact className="absolute bottom-2 left-2 z-10" />
      <img src={p.image_url} alt={p.title} loading="lazy" className="w-full aspect-square object-cover transition-transform duration-300 hover:scale-105" />
    </Link>
    <div className="p-3 flex flex-col gap-2 flex-1">
      <Link to={`/product/${p.slug}`} className="font-bold text-sm leading-tight line-clamp-2 hover:pcs-text-pink">
        {p.title}
      </Link>
      <div className="mt-auto"><Price product={p} /></div>
      <RetailerCTA product={p} size="sm" source={source} testId={`${source}-cta-${p.slug}`} />
    </div>
  </div>
);

export default function CompleteTheLook({ slug }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get(`/products/${slug}/look`, { params: { limit: 4 } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [slug]);

  if (!items.length) return null;

  return (
    <section className="border-b-2 border-black pcs-bg-blue text-white" data-testid="complete-the-look">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 mb-6 md:mb-10">
          <div>
            <div className="font-mono uppercase text-[11px] tracking-widest mb-2 inline-flex items-center gap-1.5">
              <Users className="w-3.5 h-3.5" strokeWidth={3} /> Going as a pair or a crew?
            </div>
            <h2 className="font-display text-3xl md:text-5xl tracking-tighter leading-none">Complete the look.</h2>
          </div>
          <p className="hidden md:block max-w-xs text-sm text-right">
            Pieces that pair with this one — grab them together so the whole group arrives on time.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((p, i) => <LookCard key={p.slug} p={p} i={i} />)}
        </div>
        <AffiliateNote className="mt-6 text-white/80" testId="look-affiliate-note" />
      </div>
    </section>
  );
}
